import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");
  const { clear } = useCart();

  useEffect(() => {
    if (!sid) {
      setState("error");
      return undefined;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data?.payment_status === "paid") {
          setState("paid");
          clear();
          return;
        }
        if (data?.status === "expired") {
          setState("error");
          return;
        }
      } catch (e) { /* retry */ }
      tries += 1;
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid]);

  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col justify-center px-5 pt-24" data-testid="payment-success-page">
      {state === "checking" && <><Loader2 className="h-10 w-10 animate-spin text-sky-400" /><h1 className="mt-6 font-display text-4xl font-semibold">Confirming payment…</h1></>}
      {state === "paid" && <><CheckCircle2 className="h-12 w-12 text-emerald-400" /><h1 className="mt-6 font-display text-5xl font-semibold" data-testid="payment-paid">Payment confirmed.</h1><p className="mt-4 text-slate-300">Your order is in. Our team will reach out about shipping and boarding.</p></>}
      {(state === "timeout" || state === "error") && <><XCircle className="h-12 w-12 text-amber-400" /><h1 className="mt-6 font-display text-4xl font-semibold" data-testid="payment-unconfirmed">We couldn't confirm the payment yet.</h1><p className="mt-4 text-slate-300">If you were charged, it will appear shortly. Contact us with your receipt.</p></>}
      <div className="mt-10 flex gap-3"><Link to="/store" className="btn-primary" data-testid="payment-back-store">Back to storefront</Link><Link to="/apply" className="btn-ghost">Apply for processing</Link></div>
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col justify-center px-5 pt-24" data-testid="payment-cancel-page">
      <h1 className="font-display text-5xl font-semibold">Checkout cancelled.</h1>
      <p className="mt-4 text-slate-300">Your cart is saved. Pick up where you left off whenever you're ready.</p>
      <div className="mt-10"><Link to="/store" className="btn-primary" data-testid="payment-cancel-store">Return to storefront</Link></div>
    </main>
  );
}
